import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Heart, Search, ShoppingCart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const {
    cartCount
  } = useCart();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Programs',
    href: '/programs'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Events',
    href: '/events'
  }, {
    name: 'Shop',
    href: '/shop'
  }, {
    name: 'Blog',
    href: '/blog'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const isDarkBg = location.pathname === '/' && !isScrolled;
  return <>
      <header className={`fixed py-0 top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white backdrop-blur-sm'}`} data-id="element-109" data-mp="olgnkxk3kqg6">
        <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-110" data-mp="3s279klw2re3i">
          <Link to="/" className="flex items-center" data-id="element-111" data-mp="w5snwpfhq9y">
            <img src="https://cdn.magicpatterns.com/uploads/hYuXCXijE8xA4tYjBeZUog/ChatGPT_Image_Jul_24,_2026,_02_58_54_AM.png" alt="Poch Global Logo" className="h-20 w-auto object-contain" data-id="element-112" data-mp="ul2eja5cthw" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-113" data-mp="39ao66dy51y0y">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors hover:text-gold ${isScrolled ? 'text-mediumgray' : 'text-mediumgray'} ${location.pathname === link.href ? '!text-gold' : ''}`} data-id="element-114" data-mp="319ozwrvwbj4n">
                {link.name}
              </Link>)}
          </nav>

          <div className="hidden lg:flex items-center space-x-6" data-id="element-115" data-mp="2ibm70208921k">
            <button className={`${isScrolled ? 'text-navy hover:text-gold' : 'text-mediumgray hover:text-gold'} transition-colors`} data-id="element-116" data-mp="2ddca9myuttdu">
              <Search className="w-5 h-5" data-id="element-117" data-mp="2sc6731c0g0i7" />
            </button>
            <Link to="/cart" className={`${isScrolled ? 'text-navy hover:text-gold' : 'text-mediumgray hover:text-gold'} transition-colors relative`} data-id="element-118" data-mp="2nb8seyq7lolg">
              <ShoppingCart className="w-5 h-5" data-id="element-119" data-mp="2lsw5o8817of" />
              {cartCount > 0 && <span className="absolute -top-2 -right-2 bg-burgundy text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-120" data-mp="a5237at98uab">
                  {cartCount}
                </span>}
            </Link>
            <Link to="/donate" className="group relative inline-flex items-center justify-center px-6 py-2.5 text-sm font-semibold text-white transition-all duration-200 bg-gold hover:bg-gold-light rounded-full overflow-hidden shadow-md hover:shadow-gold/20" data-id="element-121" data-mp="15otch17y3p2">
              <span className="relative z-10 flex items-center gap-2" data-id="element-122" data-mp="xtv4znwk5wcu">
                <Heart className="w-4 h-4" data-id="element-123" data-mp="k3rntbcjcsu9" />
                Donate
              </span>
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden p-2 text-navy hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(true)} data-id="element-124" data-mp="o277p6dbll3g">
            <Menu className="w-6 h-6" data-id="element-125" data-mp="1gmfgpsk4lktf" />
          </button>
        </div>
      </header>

      {/* Mobile Nav Overlay */}
      <AnimatePresence data-id="element-126" data-mp="3ozuezyf2nsud">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-[100] bg-navy flex flex-col overflow-hidden" data-id="element-127" data-mp="3k1sura5wtnhb">
            {/* Background Texture */}
            <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-128" data-mp="blpnv6mmg2u1" />
            
            {/* Header inside menu */}
            <div className="relative z-10 flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-129" data-mp="1wftfk4b282r">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center bg-white/90 p-2 rounded-xl" data-id="element-130" data-mp="3u08nfhkl54sx">
                <img src="https://cdn.magicpatterns.com/uploads/hYuXCXijE8xA4tYjBeZUog/ChatGPT_Image_Jul_24,_2026,_02_58_54_AM.png" alt="Poch Global Logo" className="h-12 w-auto object-contain" data-id="element-131" data-mp="ufmu49lhbzep" />
              </Link>
              <button className="p-2 text-white/70 hover:text-white transition-colors bg-white/10 rounded-full" onClick={() => setIsMobileMenuOpen(false)} data-id="element-132" data-mp="2d96ey76ge25k">
                <X className="w-6 h-6" data-id="element-133" data-mp="2mamfzobdorx4" />
              </button>
            </div>

            {/* Menu Links */}
            <div className="relative z-10 flex-grow flex flex-col justify-center px-6 py-4" data-id="element-134" data-mp="2r6bio0ip2oxn">
              <nav className="grid grid-cols-2 gap-y-6 gap-x-4 mb-8" data-id="element-135" data-mp="2w5edyt8vhgsf">
                {navLinks.map((link, index) => <motion.div key={link.name} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1 + index * 0.05,
              duration: 0.4
            }} data-id="element-136" data-mp="34zt27lbds1no" data-mpi={index}>
                    <Link to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={`text-xl sm:text-2xl font-serif font-bold transition-colors ${location.pathname === link.href ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-137" data-mp="3ey9xuvl9l4g2">
                      {link.name}
                    </Link>
                  </motion.div>)}
              </nav>

              {/* Utilities & CTAs */}
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.4
          }} className="mt-auto" data-id="element-138" data-mp="1xknqljt19f7j">
                <div className="flex items-center justify-center gap-8 border-t border-white/10 pt-6 mb-6" data-id="element-139" data-mp="22lbrcx72daey">
                  <button className="flex items-center gap-2 text-white/80 hover:text-gold transition-colors text-sm font-medium" data-id="element-140" data-mp="d65a5axqw5xe">
                    <Search className="w-4 h-4" data-id="element-141" data-mp="88c6opnttq0t" /> Search
                  </button>
                  <Link to="/cart" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center gap-2 text-white/80 hover:text-gold transition-colors text-sm font-medium relative" data-id="element-142" data-mp="2ju4b17p7vun9">
                    <ShoppingCart className="w-4 h-4" data-id="element-143" data-mp="2f3xmt8ymac5j" /> Cart
                    {cartCount > 0 && <span className="bg-gold text-navy text-[10px] font-bold px-1.5 py-0.5 rounded-full ml-1" data-id="element-144" data-mp="21462yrlf61jm">
                        {cartCount}
                      </span>}
                  </Link>
                </div>
                
                <div className="flex gap-3" data-id="element-145" data-mp="1r7jii3x09ci4">
                  <Link to="/donate" onClick={() => setIsMobileMenuOpen(false)} className="flex-1 bg-gold hover:bg-gold-light text-white font-bold py-3 rounded-xl text-center flex items-center justify-center gap-2 shadow-lg transition-colors text-sm" data-id="element-146" data-mp="1w4tfc4mq4qfz">
                    <Heart className="w-4 h-4" data-id="element-147" data-mp="2e8pjeoz48zkf" />
                    Donate
                  </Link>
                  <Link to="/volunteer" onClick={() => setIsMobileMenuOpen(false)} className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-3 rounded-xl text-center transition-colors text-sm" data-id="element-148" data-mp="29bpdce29nwtb">
                    Volunteer
                  </Link>
                </div>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}